import React, { useState, useEffect, useCallback } from "react";
import { BiographyContext } from "./DataContext";
import axios from "axios";
import WebAppConfig from "../components/configuration/webapp-config";

export const BiographyState = ({ children }) => {
    const [bios, setBios] = useState([]);
    const [loading, setLoading] = useState(false);
    const { config, isLoading: configLoading } = WebAppConfig();
  
    const apiUrl = "https://apievt.lacnic.net/wp-json/wp/v2/biographies";
    const pageParam = "?per_page=100";
  
    const fetchSponsors = useCallback(async () => {
        // No hacer la llamada si no tenemos el ID o si config está cargando
        if (!config.currentEventID || configLoading) {
          return;
        }
    
        setLoading(true);
        try {
          const currentEvent = `&our_events=${config.currentEventID}`;
          const responseJSON = await axios.get(
            `${apiUrl}${pageParam}${currentEvent}`
          );
          setBios(responseJSON.data);
        } catch (error) {
          console.error("Error fetching biographies:", error);
          setBios([]); // Set empty array on error
        } finally {
          setLoading(false);
        }
      }, [config.currentEventID, configLoading, apiUrl, pageParam]);
    
      useEffect(() => {
        fetchSponsors();
      }, [fetchSponsors]);
  
    const [allBiographiesUnlimited, setAllBiographiesUnlimited] = useState([]);
    const [allBiographiesUnlimitedLoading, setAllBiographiesUnlimitedLoading] =
      useState(false);
  
    const loadAllBiographiesUnlimited = async () => {
      try {
        setAllBiographiesUnlimitedLoading(true);
        const biographies = [];
  
        // Primera llamada para obtener el total de páginas
        const initialResponse = await fetch(
          `${apiUrl}?per_page=100`
        );
        if (!initialResponse.ok) {
          throw new Error(
            `Failed to fetch biographies: ${initialResponse.status} ${initialResponse.statusText}`
          );
        }
  
        // Obtener el total de páginas desde los headers
        const totalPages =
          parseInt(initialResponse.headers.get("X-WP-TotalPages")) || 1;
  
        // Obtener la primera página
        const firstPageBiographies = await initialResponse.json();
        biographies.push(...firstPageBiographies);
  
        // Obtener las páginas restantes si hay más de una página
        if (totalPages > 1) {
          const remainingPages = [];
          for (let page = 2; page <= totalPages; page++) {
            remainingPages.push(
              fetch(`${apiUrl}?per_page=100&page=${page}`).then(
                (response) => {
                  if (!response.ok) {
                    throw new Error(
                      `Failed to fetch biographies for page ${page}: ${response.status} ${response.statusText}`
                    );
                  }
                  return response.json();
                }
              )
            );
          }
  
          // Esperar a que todas las páginas se carguen
          const remainingResults = await Promise.all(remainingPages);
          remainingResults.forEach((pageBiographies) => {
            biographies.push(...pageBiographies);
          });
        }
  
        setAllBiographiesUnlimited(biographies);
      } catch (error) {
        console.error("[UNLIMITED] Error loading biographies:", error);
      } finally {
        setAllBiographiesUnlimitedLoading(false);
      }
    };
  
    // Nuevo useEffect para obtener TODOS los biographies sin límite
    useEffect(() => {
      loadAllBiographiesUnlimited();
    }, [apiUrl]);
  
    return (
      <BiographyContext.Provider
        value={{
          bios,
          loading: loading || configLoading, // También considerar el loading de config
          allBiographiesUnlimited,
          allBiographiesUnlimitedLoading,
          refreshBiographies: fetchSponsors,
          refreshAllBiographies: loadAllBiographiesUnlimited
        }}
      >
        {children}
      </BiographyContext.Provider>
    );
  };